/* eslint-disable @typescript-eslint/no-explicit-any */
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class TmpAssetStorageService {
  $asset = new BehaviorSubject<any>({});

  updateAsset(asset: any) {
    this.$asset.next(asset);
  }

  getAsset(): Observable<any> {
    return this.$asset.asObservable();
  }
}
